import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AuthContext = /*#__PURE__*/createContext(null);
export const ProvideAuth = ({
  hasScope,
  hasGate,
  children
}) => {
  const value = useMemo(() => ({
    hasScope,
    hasGate
  }), [hasScope, hasGate]);
  return /*#__PURE__*/_jsx(AuthContext.Provider, {
    value: value,
    children: children
  });
};
export const useAuth = () => useContext(AuthContext);